import { DEFAULT_COLORS } from "@/constants/CColors";

export const rgbToHex = ({ r, g, b }: { r: number; g: number; b: number }) => {
	const toHex = (c: number) => {
		const hex = c.toString(16);
		return hex.length == 1 ? "0" + hex : hex;
	};

	return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

export const intToHex = (i: number) => {
	const hex = i.toString(16);
	return hex.length == 1 ? "0" + hex : hex;
};

export const getRandomDefaultColor = () => {
	const randomIndex = Math.floor(Math.random() * DEFAULT_COLORS.length);
	return DEFAULT_COLORS[randomIndex];
};
